export default __webpack_public_path__ + "static/media/badges_reduced.8c1f7733.jpg";